const analytics = () => {
  return {
    logScreenView: function (_: { screen_name: string; screen_class: string }) {
      // intentionally do nothing - the native version does something though.
      console.warn("[analytics]logScreenView not implemented in web");
    },
  };
};

export { analytics };

export async function sendAnalyticsEventAsync(
  eventName: string,
  eventParams: Record<string, any> = {}
) {
  window?.dataLayer?.push({
    event: eventName,
    ...eventParams,
  });
}
